















import { Component, Vue } from 'vue-property-decorator'
import PageHead from '@/components/PageHead.vue'

@Component({
  components: {
    PageHead,
  },
})
export default class GdprCompliance extends Vue {
  pageTitle = 'GDPR & DUAA Compliance'
  placeholderText = 'Is your website GDPR compliant and prepared for the 19 June 2026 DUAA (Data Use and Access Act) deadline? Introducing http://PolicyDiary.co.uk - a simple, low-cost solution that takes care of your website\'s privacy policies, cookie policies, GDPR documentation and complaints procedure requirements, with automatic updates whenever compliance rules change. All for just £24 per year.'
  placeholderUrl = 'https://policydiary.co.uk'
}
